import React from 'react';
import * as navigate from 'app/area/shared/navigation';
import { Waypoint } from 'react-waypoint';
import { ButtonPrimary, ElementLoader } from 'ui';
import { deepEquals } from 'app/infrastructure/js';
import { SearchFilters } from 'app/area/search-filters/search-filters';
import { SerializePayload } from 'app/area/search-filters/types';
import { ExternalUrlsSearchModel, ListRendererProps } from '../types-store';
import { serialize } from '../serialize';
import { ListResults } from './list-results';
import styles from './list-renderer.scss';
import { routeConstants } from 'app/routes/route-constants';

export const ListRenderer: React.FC<ListRendererProps> = ({
  listState, loadList, deleteExternalUrl, translation
}) => {

  const { fetching, requestedSearchModel, listItems, numberOfResults, deletingExternalUrls } = listState;

  const updateSearchModel = (payload: SerializePayload) => {
    onLoadData(serialize(payload));
  };

  const onLoadData = (searchModel: ExternalUrlsSearchModel, startIndex?: number) => {

    if (startIndex !== undefined || !deepEquals(searchModel, requestedSearchModel)) {
      loadList(searchModel, startIndex);
    }
  };

  const onFetchMore = () => {

    if (fetching || !listItems || listItems.length === 0 || listItems.length === numberOfResults) {
      return;
    }

    onLoadData(requestedSearchModel, listItems.length);
  };

  const onCreate = () =>
    navigate.replace(routeConstants.externalUrlAddFor());

  const topToolbar = <div className="row">
    <h1 className="col-12">
      {translation.external_urls}
    </h1>
  </div>;

  const rightToolbar = <ButtonPrimary
    id={'add-new-external-url'}
    onClick={onCreate}>
    {translation.add_new}
  </ButtonPrimary>;

  return <>
    <SearchFilters
      topToolbar={topToolbar}
      rightToolbar={rightToolbar}
      filtersConfig={{ area: 'externalUrlAdmin' }}
      hideDrawer={true}
      queryFilters={undefined}
      predefinedFilters={undefined}
      customFilters={undefined}
      defaultFilterValues={undefined}
      updateSearchModel={updateSearchModel}>
      {!!listItems && <div className="row">
        <div className="col-12">
          <div id="external_urls_number_of_results"
            className={styles.noOfResults}>
            {numberOfResults === 0
              ? translation.search_no_external_urls
              : `${numberOfResults} ${translation.search_hits}`}
          </div>
        </div>
      </div>}
      {listItems && listItems.length > 0
        ? <ListResults
          listItems={listItems}
          deletingExternalUrls={deletingExternalUrls}
          deleteExternalUrl={deleteExternalUrl}
          translation={translation} />
        : null}
      <Waypoint key="wpExternalUrlsAdmin" onEnter={onFetchMore} scrollableAncestor={window} bottomOffset="-10%" />
      {listState.fetching ? <ElementLoader /> : null}
    </SearchFilters>
  </>;
};
